import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { ApiError } from "@/lib/api-client";
import { localizeFieldIssue } from "@/lib/errorMessages";

/**
 * Map a backend {@code VALIDATION_FAILED} envelope onto react-hook-form
 * errors via {@link UseFormReturn.setError}. Returns true when the error
 * was handled (so callers can skip the generic toast path), false when
 * the error was something else and the caller should surface it itself.
 *
 * Field names in the backend envelope must match the form's field
 * names; this is the existing contract on the backend side.
 */
export function applyServerValidationErrors<T extends FieldValues>(
  form: UseFormReturn<T>,
  apiError: ApiError,
): boolean {
  if (apiError.body?.code !== "VALIDATION_FAILED") return false;
  const details = apiError.body.details ?? [];
  if (details.length === 0) return false;
  for (const detail of details) {
    form.setError(detail.field as Path<T>, {
      type: "server",
      message: localizeFieldIssue(detail.issue),
    });
  }
  return true;
}
